export default {
  data() {
    return {
      settings: {
        sendLabel: 'add_coupon',
        btnSize: 3,
      },
      groups: {
        coupon: {
          visible: true,
          size: 9,
          fields: {
            coupon: {
              type: 'text',
              model: null,
              placeholder: 'Coupon',
              label: 'insert_coupon',
            },
          },
        },
      },
    };
  },
  methods: {
    init() {
    },
    async callback() {
      this.$store.dispatch('addCoupon', {
        coupon: this.groups.coupon.fields.coupon.model,
      });
    },
  },
};
